import { type GetPositionsOfPaymentPrefQuery } from "#graphql/supergraphTypes";
import { type PositionsPaginatedType } from "../../../common/types";

export const getPositionsPaginated = (
  data: GetPositionsOfPaymentPrefQuery | undefined,
): PositionsPaginatedType | undefined => {
  return data?.paymentPrefs?.[0]?.positionsPaginated ?? undefined;
};
